import { useState, useEffect, useRef } from 'react';
import { useAuthContext } from '@hooks/useAuthContext';
import { Logo } from '@components';
import { STYTCH_PUBLIC_TOKEN } from '@constants';
import { Navigate, useLocation } from 'react-router-dom';
import InfoDoneIcon from '@assets/info_done.svg';
import {
  StytchLogin, StytchPasswordReset, useStytch,
} from '@stytch/react';
import request from '@api';
import qs from 'query-string';
import { Products } from '@stytch/vanilla-js';
import Img from './Img';
import './index.css';

import classes from './index.module.css';
import { useEffectOnce } from '../../hooks';

const imgData = 'data:image/png;base64,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';

function Login() {
  const location = useLocation();
  const { login } = useAuthContext();
  const stytchClient = useStytch();
  const [emailInfo, setEmailInfo] = useState({ email: '', sessionToken: '' });
  const [msgTip, setMsgTip] = useState(false);
  let { current: timerId } = useRef();

  const { token: resetToken } = qs.parse(window.location.search);
  // 只有login，才去判断是不是有登录态
  const isLogined = login && location.pathname.indexOf('login') > -1;
  if (isLogined) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  const loginHref = window.location.origin;
  const authRedirectUrl = `${window.location.origin}/authenticate`;
  const resetPasswordUrl = `${window.location.origin}/reset-password`;

  const sendStytchEmail = async ({
    email, sessionToken,
  }) => {
    // https://stytch.com/docs/sdks/react-native-sdk/email-magic-links
    try {
      stytchClient.magicLinks.email.send(email, {
        signup_magic_link_url: authRedirectUrl,
        signup_expiration_minutes: 60,
        login_magic_link_url: authRedirectUrl,
        login_expiration_minutes: 60,
        session_token: sessionToken,

      });
      // 调用stytch发邮件api，发送成功后设置emailName
      setEmailInfo({
        email, sessionToken,
      });
      // 存储session_token 在authenticate时候需要使用
      localStorage.setItem('sessionToken', sessionToken);
    } catch (error) {
      console.log(error);
    }
  };

  // 调用接口写cookie -> stytch_session_token_dev/stytch_session_token
  const seelAuthenticate = async (sessionToken, email) => {
    try {
      const { code, data: { userRegistered } } = await request('authenticate', {
        method: 'POST',
        body: { sessionToken },
      });
      // console.log('authenticate api result:', code, userRegistered);
      if (code === 0) {
        if (userRegistered) {
          window.location.href = loginHref;
        } else {
          sendStytchEmail({
            email, sessionToken,
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const resendEmail = () => {
    sendStytchEmail(emailInfo);
    setMsgTip(true);
  };
  const handleLeftArrowClick = () => {
    setEmailInfo({});
  };
  const stytchProps = {
    loginOrSignupView: {
      products: [Products.passwords, Products.emailMagicLinks],
      emailMagicLinksOptions: {
        loginRedirectURL: authRedirectUrl,
        loginExpirationMinutes: 60,
        signupRedirectURL: authRedirectUrl,
        signupExpirationMinutes: 60,
        createUserAsPending: true,
      },
      passwordOptions: {
        loginRedirectURL: authRedirectUrl,
        resetPasswordRedirectURL: resetPasswordUrl,
        reset_password_expiration_minutes: 60,
      },
    },
    style: {
      // fontFamily: 'Arial',
      width: '400px',
      primaryColor: '#645AFF',
      hideHeaderText: false,
      darkGrey: '#C9CCCF',
      buttons: {
        primary: {
          backgroundColor: '#645AFF',
          textColor: '#FFFFFF',
          borderColor: '#19303D',
          borderRadius: '4px',
        },
        secondary: {
          backgroundColor: '#FFFFFF',
          textColor: '#645AFF',
          borderColor: '#645AFF',
          borderRadius: '4px',
        },
      },
      container: {
        backgroundColor: '#FFFFFF',
        borderColor: '#fff',
        // borderRadius: '8px',
        border: 'none',
        width: '400px',
      },
      colors: {
        primary: '#19303D',
        secondary: '#5C727D',
        success: '#0C5A56',
        error: '#8B1214',
      },

      secondary: {
        backgroundColor: '#FFFFFF',
        textColor: '#19303D',
        // borderColor: '#19303D',
        borderRadius: '4px',
      },
    },
    publicToken: STYTCH_PUBLIC_TOKEN,
    logo: {
      logoImageUrl: imgData,
    },
    callbacks: {
      onEvent: async ({ data = {}, type }) => {
        // console.log(data, type, 'data');
        const { user: { emails } = {} } = data;
        if (type === 'MAGIC_LINK_LOGIN_OR_CREATE') {
          // TODO: check whether the user exists in your DB
        }
        // 判断是否是密码登录
        if (['PASSWORD_AUTHENTICATE', 'PASSWORD_CREATE'].includes(type)) {
          // 密码登录，stytch验证成功。调用接口看看是不是seel MD用户，是则接口写入stytch cookie，否则发邮件走reset psd流程
          seelAuthenticate(data.session_token, emails[0]?.email);
        }
      },
      onSuccess: console.log,
      onError: console.log,
    },
    resetCallbacks: {
      onEvent: async ({ data = {}, type }) => {
        console.log(data, type, 'reset psd data');
        // TODO reset 成功后，直接调用接口写stytch cookie，然后跳到首页
        if (type === 'PASSWORD_RESET_BY_EMAIL') {
          seelAuthenticate(data.session_token);
        }
      },
      onSuccess: console.log,
      onError: console.log,
    },

  };
  // 设置tip msg
  useEffect(() => {
    clearTimeout(timerId);
    if (msgTip) {
      timerId = setTimeout(() => {
        setMsgTip(false);
      }, 3000);
    }
  }, [msgTip, timerId]);
  useEffectOnce(() => {
    // login时，移除 stytch cookie--stytch_session 防止混淆
    if (!isLogined && !emailInfo.email) {
      document.cookie = 'stytch_session=';
    }
  });
  return (
    <div className={classes.paper}>
      {/* <Circle /> */}
      <div className={classes.left}>
        <Img />
        <div className={classes.left_tips}>
          The insurance platform powering commerce
          We helped 600,000+ shoppers at 500+ stores shop with peace of mind. Yours is the next.
        </div>
      </div>
      <div className={classes.right}>
        {emailInfo.email ? (
          <div className={classes.right_tips}>
            <div onClick={handleLeftArrowClick} className={classes.left_arrow_icon}>
              {/* stytch的arrow icon */}
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z" fill="#19303D"></path></svg>
            </div>
            <Logo />
            <div className={classes.email_tips}>
              <div className={classes.verify}>{`A verification email was sent to you at ${emailInfo.email}.`}</div>
              <div className={classes.not_get}>
                Didn&apos;t get it?
                <span className={classes.resend_email} onClick={resendEmail}>Resend Email</span>
                {msgTip
                  && (
                    <div className={classes.msg_tip}>
                      {/* <div className={classes.done_img}> */}
                      <img src={InfoDoneIcon} alt="" />
                      {/* </div> */}
                      Email resent
                    </div>
                  )}
              </div>
            </div>

          </div>
        )
          : (
            <div className={classes.stytch_container}>
              <Logo />
              {resetToken ? (
                <StytchPasswordReset
                  config={stytchProps.loginOrSignupView}
                  passwordResetToken={resetToken}
                  callbacks={stytchProps.resetCallbacks}
                />
              ) : (
                <StytchLogin
                  config={stytchProps.loginOrSignupView}
                  styles={stytchProps.style}
                  callbacks={stytchProps.callbacks}
                />
              )}
            </div>
          )}
      </div>
    </div>
  );
}

export default Login;
